module.exports = __webpack_public_path__ + "static/media/no-image.23b05541.svg";